<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <emp-cms-entrance-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></emp-cms-entrance-form>
  </j-modal>
</template>

<script>

  import EmpCmsEntranceForm from './EmpCmsEntranceForm'
  export default {
    name: 'EmpCmsEntranceModal',
    components: {
      EmpCmsEntranceForm
    },
    data () {
      return {
        title:'',
        width:1200,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>